import Lottie from "lottie-react";

import "./loader.scss";
import LoaderIcon from "../../assets/Search.json";

const Loader = () => {
  return (
    <div id="overlay">
      <div className="loader-icon">
        <Lottie loop={true} animationData={LoaderIcon} width={10} />
      </div>
    </div>
  );
};

export default Loader;
